var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlacesToEat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.805,
    height: 32.4,
    viewBox: "0 0 31.805 32.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.467 -2.938)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1208",
    d: "M49.57 12.856a1.311 1.311 0 0 0 1.249-1.371 1.311 1.311 0 0 0-1.371-1.249l-.491.023-.023-.491a1.311 1.311 0 1 0-2.619.122L46.46 13zm.606 3.861-.018.379-.379-.018a1.011 1.011 0 0 0-.094 2.019l2.4.111.111-2.4a1.011 1.011 0 0 0-.963-1.056 1.01 1.01 0 0 0-1.057.966z",
    transform: "translate(-19.064 -2.508)",
    style: {
      fill: "#ea7d36"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 673",
    cx: 0.688,
    cy: 0.688,
    r: 0.688,
    transform: "translate(25.563 2.938)",
    style: {
      fill: "#ea7d36"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 674",
    cx: 0.688,
    cy: 0.688,
    r: 0.688,
    transform: "translate(32.445 4.988)",
    style: {
      fill: "#ea7d36"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 675",
    cx: 0.688,
    cy: 0.688,
    r: 0.688,
    transform: "translate(26.251 12.558)",
    style: {
      fill: "#ea7d36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1209",
    d: "m9.627 12.856 3.11.144.145-3.111a1.311 1.311 0 0 0-1.249-1.369 1.311 1.311 0 0 0-1.371 1.249l-.023.491-.491-.023a1.311 1.311 0 0 0-1.371 1.249 1.311 1.311 0 0 0 1.25 1.37zM7 16.811l.111 2.4 2.4-.111a1.011 1.011 0 0 0-.094-2.019l-.379.018-.018-.379a1.011 1.011 0 1 0-2.02.091z",
    transform: "translate(-1.394 -2.508)",
    style: {
      fill: "#ea7d36"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 676",
    cx: 0.688,
    cy: 0.688,
    r: 0.688,
    transform: "translate(11.8 2.938)",
    style: {
      fill: "#ea7d36"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 677",
    cx: 0.688,
    cy: 0.688,
    r: 0.688,
    transform: "translate(4.918 4.988)",
    style: {
      fill: "#ea7d36"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 678",
    cx: 0.688,
    cy: 0.688,
    r: 0.688,
    transform: "translate(11.112 12.558)",
    style: {
      fill: "#ea7d36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1210",
    d: "M19.37 23.38a2.409 2.409 0 1 0-2.409-2.409 2.412 2.412 0 0 0 2.409 2.409zm0-4.129a1.72 1.72 0 1 1-1.72 1.72 1.722 1.722 0 0 1 1.72-1.72zM3.9 37.832a4.479 4.479 0 0 0 4.46 4.129h22.02a4.479 4.479 0 0 0 4.46-4.129z",
    transform: "translate(0 -7.023)",
    style: {
      stroke: "#1f0f04",
      strokeWidth: ".8px",
      fill: "#ea7d36"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1211",
    d: "M6.383 41.076h2.754a11.409 11.409 0 0 1 5.671-9.487.344.344 0 0 1 .345.6 10.717 10.717 0 0 0-5.328 8.891H34.59a14.108 14.108 0 0 0-28.207 0zm14.1-11.011a11.263 11.263 0 0 1 4.258.829.344.344 0 1 1-.259.638 10.58 10.58 0 0 0-4-.778.344.344 0 0 1 0-.688z",
    transform: "translate(-1.116 -10.955)",
    style: {
      stroke: "#1f0f04",
      strokeWidth: ".8px",
      fill: "#ea7d36"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacesToEat);
export default __webpack_public_path__ + "static/media/places-to-eat.19714ba4414f700b92c4eb98e8fc7be3.svg";
export { ForwardRef as ReactComponent };